import { logger } from '@fiverr-private/obs';
import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';

export const reportSearchFilterEvent = (type, { searchTerm, resultsAmount, highlightedAmount } = {}) => {
    if (!type.BigQuery) {
        logger.warn('BigQuery event type is not defined', { func: 'reportSearchFilterEvent' });
    } else {
        tracker.sendBQEvent(
            getBQClickFields({
                type: type.BigQuery,
                text: searchTerm,
                elementType: 'search_filter',
                elementMetadata: {
                    results_num: resultsAmount,
                    highlighted_num: highlightedAmount,
                },
                componentName: 'reviews_header',
            })
        );
    }
};

export const TYPES = {
    focus: {
        BigQuery: 'reviews_search_filter_focused',
    },
    searched: {
        successfully: {
            BigQuery: 'reviews_filter.search',
        },
        failed: {
            BigQuery: 'reviews_filter.search.failed',
        },
    },
};
